import { useEffect, useMemo } from 'react';
import { useGetAllOrdersQuery } from '../../../redux/commonRTK';
import { getMerchant } from '../../../helpers/ReduxHelpers';
import { ABD_INCLUDES, buildBaselineAndFilter, buildBaselineOrFilter, fmt } from './constants';

const DEFAULT_SORT = { field: 'awbRegisteredDate', direction: 'DESC' };

export default function useAppointmentSearch({
    filters = {},
    extraAndFilter = [],
    extraOrFilter = [],
    page = 0,
    sizePerPage = 50,
    skipCount = false,
    reload = 0,
    appointmentRequired = true,
    sort = DEFAULT_SORT,
}) {
    const merchant = getMerchant();
    const merchantId = merchant?.id || '';

    const extraAndKey = JSON.stringify(extraAndFilter);
    const extraOrKey = JSON.stringify(extraOrFilter);
    const filtersKey = JSON.stringify({
        awb: filters.awb || '',
        clientOrderId: filters.clientOrderId || '',
        city: filters.city || '',
        state: filters.state || '',
        courier: filters.courier || '',
        reference: filters.reference || '',
        attempts: filters.attempts || '',
        missCategory: filters.missCategory || '',
        documents: filters.documents || '',
        fromDate: fmt(filters.fromDate),
        toDate: fmt(filters.toDate),
    });

    const request = useMemo(() => {
        const andfilter = [...buildBaselineAndFilter(filters, merchantId, appointmentRequired), ...extraAndFilter];
        const orfilter = [...buildBaselineOrFilter(filters), ...extraOrFilter];

        return {
            andfilter,
            orfilter,
            offset: page * sizePerPage,
            limit: sizePerPage,
            skipCount,
            includes: ABD_INCLUDES,
            sort,
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtersKey, extraAndKey, extraOrKey, page, sizePerPage, skipCount, merchantId, reload, appointmentRequired, sort.field, sort.direction]);

    const result = useGetAllOrdersQuery(request);

    // Force-refetch when reload bumps (RTK Query caches by arg shape; reload
    // doesn't appear in the request body so a bump alone won't bust the cache).
    useEffect(() => {
        if (reload > 0 && result.refetch) {
            const t = setTimeout(() => result.refetch(), 800);
            return () => clearTimeout(t);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reload]);

    return { ...result, request };
}
